export const breadcrumbItem = {
  background: "#f2f2f2",
  color: "#404040",
  fontSize: "1rem",
  lineHeight: "1.5",
  fontWeight: 400,
  fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif"
};

export const breadcrumbItemActive = {
  background: "#f2f2f2",
  color: "#404040",
  fontSize: "1rem",
  lineHeight: "1.5",
  fontWeight: 700,
  fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif"
};
